module.exports = __webpack_public_path__ + "static/img/14064B_R_3_20171016_fit.44eee26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14064B_R_3_20171016_fit.png
// module id = WsBU
// module chunks = 0